import { Container, Image } from "react-bootstrap";
import logo from "../img/naep_logo.png";
import { useTranslation } from "react-i18next";
import "../index.css";

function Header() {
  const { t } = useTranslation();
  return (
    <Container
      style={{
        // top: "0rem",
        // position: "relative",
        padding: "0",
        margin: "0",
        height: "4.5rem",
      }}
      className="sticky-header"
    >
      <div className="flex-container-spacing">
        <Image src={logo} alt={t("logoAlt")} />
        <h4 className="logo-header">{t("headerTitle")}</h4>
      </div>
    </Container>
  );
}

export default Header;
